module.exports = "/virtual-football-league/img/amblems/left/Germany/Fake_Bayern.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Germany/Fake_Bayern.png
// module id = 2034
// module chunks = 4